/// \file securityUsers.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import {lazy, Suspense} from "react";
import { ActionFunctionArgs, LoaderFunctionArgs, Route } from "react-router-dom";

const SecurityUsersList = lazy(() => import('../views/security-users/list/view'));

async function securityUsersDataLoader(args: LoaderFunctionArgs) {
  const actualLoader = (await import('../views/security-users/list/loader')).default;
  return actualLoader(args);
}

export async function securityUsersAction(args: ActionFunctionArgs) {
  const actualAction = (await import("../views/security-users/list/action")).action;
  return actualAction(args);
}

const routes = (
  <Route
    path="securityUsers"
    handle={{
      text: 'Security Users'
      }}
  >
    <Route 
      index
      element={
        <Suspense fallback={<div>Loading...</div>}>
          <SecurityUsersList />
        </Suspense>
      }     
      loader={securityUsersDataLoader}
      action={securityUsersAction}
      />
  </Route>
);

export default routes;